import React, { useContext, useState } from 'react';
import './expandableBox.css';
import { Button } from '@mui/material';
import { Avatar } from '@mui/material';
import { Link, Project, Mechanic } from '../../StateContext';
import { StateContext } from '../../StateContext';
import DeleteConfirmation from '../DeleteConfirmation';
import PrintablePage from '../PrintablePages';
import PrintableMechanicPage from '../PrintablePages/PrintableMechanicPage';
import { useLanguage } from '../../Services/LanguageContext';

interface IProps {
    type?: string;
    about: string;
    name: string;
    id: number;
    onDelete: (x: any) => void;
    renderButtons:
        | React.ReactNode
        | React.ReactNode[]
        | React.JSX.Element
        | React.JSX.Element[];
    toDoButton?: React.ReactNode | React.ReactNode[];
    notesButton?: React.ReactNode | React.ReactNode[];
    children?: React.ReactNode | React.ReactNode[];
    link?: Link[];
    project?: Project;
    mechanic?: Mechanic;
}

const ExpendableBox = (props: IProps) => {
    const [open, setOpen] = useState(false);
    const { t } = useLanguage();
    const { loginData } = useContext(StateContext);
    const isAdmin = loginData?.user?.isAdmin ?? false;

    const handleClickOpen = (x) => {
        x.stopPropagation();
        setOpen(true);
    };

    const handleClose = (x) => {
        x.stopPropagation();
        setOpen(false);
    };

    const handleDeleteAndClose = (x: any) => {
        props.onDelete(x);
        handleClose(x);
    };

    return (
        <div className='expandable-box'>
            <div className='box-top-container'>
                <div className='box-avatar-container'>
                    <div className='box-avatar'>
                        <Avatar
                            sx={{
                                width: 76,
                                height: 76,
                                bgcolor: 'transparent',
                                fontSize: '28px',
                                fontWeight: 700,
                                color: 'var(--accent-cyan)',
                            }}
                        >
                            {props.name.charAt(0).toUpperCase()}
                        </Avatar>
                    </div>
                </div>
                <div className='box-name-description'>
                    <div className='box-name-type-container'>
                        <h2 className='box-name'>{props.name}</h2>
                        {props.type && (
                            <span className='box-type-container'>{props.type}</span>
                        )}
                    </div>
                    <p className='box-description'>{props.about}</p>
                </div>
                {props.project ? (
                    <PrintablePage project={props.project} link={props.link} />
                ) : props.mechanic ? (
                    <PrintableMechanicPage mechanic={props.mechanic} />
                ) : null}
            </div>

            {props.children && (
                <div className='box-content'>
                    {props.children}
                </div>
            )}

            <div className='box-button-container'>
                <div className='box-left-buttons'>
                    {isAdmin && props.project?.createdByUserName && (
                        <span style={{
                            fontSize: '11px',
                            color: 'var(--text-muted, #888)',
                            alignSelf: 'center',
                            marginRight: '8px',
                        }}>
                            {props.project.createdByUserName}
                        </span>
                    )}
                    <Button
                        variant='outlined'
                        color='error'
                        onClick={handleClickOpen}
                        sx={{
                            borderRadius: '10px',
                            textTransform: 'none',
                            fontWeight: 600,
                            padding: '8px 20px',
                            minWidth: 'auto',
                            borderColor: 'rgba(239, 68, 68, 0.5)',
                            color: '#ef4444',
                            '&:hover': {
                                borderColor: '#ef4444',
                                background: 'rgba(239, 68, 68, 0.1)',
                                boxShadow: '0 0 15px rgba(239, 68, 68, 0.2)',
                            },
                        }}
                    >
                        {t('delete')}
                    </Button>
                    <DeleteConfirmation
                        handleDialogAbort={handleClose}
                        handleDialogConfirm={handleDeleteAndClose}
                        dialogOpen={open}
                    />
                    {props.toDoButton}
                    {props.notesButton}
                </div>
                <div className='box-right-buttons'>{props.renderButtons}</div>
            </div>
        </div>
    );
};

export default ExpendableBox;
